import React, { Fragment, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { bool, shape } from "prop-types";
import { routerActions } from "connected-react-router";
import * as i18n from "util/i18n";
import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";
import { actions as formActions, selectors as formSelectors } from "reducers/form";
import { useParams } from "react-router-dom";
import { actions as settingsActions } from "reducers/settings";

import Notification from "pages/_components/Notification";
import MainContainer from "pages/_components/MainContainer";
import GridTable from "pages/_components/GridTable/GridTable";
import { Col, Row } from "react-bootstrap";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import { TransactionCard, TransactionHeader, TransactionSign } from "pages/_components/TransactionCard";
import I18n from "pages/_components/I18n";
import Button from "pages/_components/Button";
import useReactPrint from "pages/_components/Print/useReactToPrint";
import { ResponsiveHeader } from "pages/_components/header";
import CustomData from "pages/_components/CustomData/CustomData";
import { isIOS } from "react-device-detect";
import { transactionStatus } from "pages/transactions/constants";

const OtrosProductosSuccessTicket = ({ transaction, isDesktop }) => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const params = useParams();
    const { componentRef, handlePrint, mobileRef, handleShareMobile } = useReactPrint(
        `loan.productTypes.${transaction?.data?.productType}`,
        id,
        "accounts",
    );
    const [buttonLabel, setButtonLabel] = useState("echecks.seeLess.button");
    const [showMoreData, setShowMoreData] = useState(!isDesktop);

    const handleDownload = async () => {
        await setShowMoreData(true);
        return handlePrint();
    };

    const handleSeeMoreData = () => {
        setShowMoreData(!showMoreData);
        if (!showMoreData) {
            setButtonLabel("echecks.seeLess.button");
        } else {
            setButtonLabel("echecks.seeMore.button");
        }
    };
    useEffect(() => {
        dispatch(settingsActions.getUserData());
        dispatch(accountsActions.cleanNewAccountTicket());
    }, []);
    useEffect(() => {
        if (params) {
            dispatch(formActions.readTransactionTicket(id));
        }
    }, [id]);
    const isLoading = !transaction?.data;

    const headerTicket = () => (
        <>
            <div className="ticket__wrapper col-12">
                <div className="d-flex col-12 justify-content-center align-items-center">
                    <CustomData
                        dataClass=" justify-content-center align-items-center"
                        titleText="product.request.mail.body.productTypeSimple"
                        titleTextType="I18N"
                        valueText={`${i18n.get(`loan.productTypes.${transaction?.data?.productType}`)}`}
                    />
                </div>
            </div>
        </>
    );
    const showMoreTicket = () => (
        <>
            <div className="view-more-data-button" id="element-to-ignore">
                <div className="ticket__divider inside-ticket__body">
                    <div className="ticket__notch ticket__notch--left"> </div>
                    <div className="ticket__notch ticket__notch--right"> </div>
                </div>
                <Button
                    aria-expanded={showMoreData ? "true" : "false"}
                    className="more-button"
                    label={buttonLabel}
                    bsStyle="link"
                    onClick={handleSeeMoreData}
                    image={showMoreData ? "figma/icon/arrow-up.svg" : "figma/icon/arrow-down.svg"}
                />
            </div>

            <div className={`col-12 view-more-data ${showMoreData ? "expand " : "collapse"}`}>
                <h2>
                    <I18n id="forms.formData.requestData" />
                </h2>

                <CustomData
                    titleText="checks.control.name"
                    titleTextType="I18N"
                    valueText={transaction?.data?.user?.clientName}
                />

                <CustomData
                    titleText="checks.control.lastName"
                    titleTextType="I18N"
                    valueText={transaction?.data?.user?.clientLastName}
                />

                <CustomData
                    titleText="checks.control.dni"
                    titleTextType="I18N"
                    valueText={transaction?.data?.user?.documentNumber}
                />

                <CustomData
                    titleText="administration.users.invite.mobilePhone.label"
                    titleTextType="I18N"
                    valueText={transaction?.data?.mobileNumber}
                />

                <CustomData
                    titleText="administration.users.export.email"
                    titleTextType="I18N"
                    valueText={transaction?.data?.corporateMail}
                />

                <CustomData
                    titleText="transfers.send.mail.comment"
                    titleTextType="I18N"
                    valueText={transaction?.data?.comment}
                />
                <TransactionSign creationTime isSmall hasVaucher isDesktop={isDesktop} showMoreData={showMoreData} />
            </div>
        </>
    );
    return (
        <Fragment>
            <Notification scopeToShow="accounts" /> <ResponsiveHeader ticket id="loans.otherProducts.title" />
            <MainContainer showLoader={isLoading}>
                <div className="container" ref={componentRef}>
                    <div ref={mobileRef}>
                        <TransactionCard transaction={transaction}>
                            <TransactionHeader
                                title={i18n.get("", "Otras solicitudes")}
                                subTitle={i18n.get("", "Solicitud pendiente de respuesta del Banco")}
                                isDesktop
                                titleWithI18N={false}
                                subTitleWithI18N={false}
                                status={transactionStatus.AWAITING}
                            />
                            <div className="ticket account-pending">
                                <div className="ticket__wrapper">
                                    <div className="ticket__header" />
                                    <div className="ticket__body ticket__full-width">
                                        <GridTable>
                                            <GridTable.Container>{headerTicket()}</GridTable.Container>
                                            {showMoreTicket()}
                                        </GridTable>
                                    </div>
                                    <div className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
                                </div>
                            </div>
                        </TransactionCard>
                    </div>
                </div>
                <Row className="form-actions">
                    <>
                        <Col xs={12} md={4} mdOffset={2}>
                            <CustomButton
                                func={() => dispatch(routerActions.push("/desktop"))}
                                text="forms.transaction.ticket.actions.backToHome"
                                textType="I18N"
                                className="btn btn-outline"
                            />
                        </Col>
                        <Col xs={12} md={4} className={isIOS && "mt-8"}>
                            <Button
                                className="btn btn-primary"
                                image="images/figma/icon/download.svg"
                                label="global.download"
                                onClick={handleDownload}
                            />
                        </Col>
                        {!isDesktop && (
                            <Col xs={12} md={4} mdOffset={2} className={isIOS && "mt-8"}>
                                <Button
                                    className="btn btn-outline"
                                    image="images/figma/icon/share.svg"
                                    label="global.share"
                                    onClick={() => {
                                        handleShareMobile();
                                    }}
                                />
                            </Col>
                        )}
                    </>
                </Row>
            </MainContainer>
        </Fragment>
    );
};

OtrosProductosSuccessTicket.propTypes = {
    isDesktop: bool.isRequired,
    transaction: shape({}).isRequired,
    // fetching: oneOfType([string, bool]),
};

OtrosProductosSuccessTicket.defaultProps = {
    // fetching: false,
};

const mapStateToProps = (state) => ({
    accounts: accountsSelectors.getAccounts(state),
    fetchingAccounts: accountsSelectors.getFetching(state),
    transaction: formSelectors.getTransaction(state),
});

export default connect(mapStateToProps)(OtrosProductosSuccessTicket);
